import React, { useState, useEffect, useRef } from 'react';
import { Search, Grid, List, MoreVertical, Plus, Users, TrendingUp, TrendingDown, ChevronDown, ChevronRight, Briefcase, CheckCircle, DollarSign, X, Trash2, Edit, Eye, Upload, Camera, Pencil, Check } from 'lucide-react';
import { toast } from 'sonner';

const RealEstateClientsCustomers = () => {
  const [activeTab, setActiveTab] = useState('Clients');
  const [clientFilter, setClientFilter] = useState('A-Z');
  const [customerFilter, setCustomerFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [customerSearchTerm, setCustomerSearchTerm] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showAddCustomerModal, setShowAddCustomerModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [editItem, setEditItem] = useState(null);
  const [viewMode, setViewMode] = useState('grid');
  const dropdownRef = useRef(null);
  const fileInputRef = useRef(null);
  const customerFileInputRef = useRef(null);

  const initialClients = [
    { id: 1, name: 'Premium Properties LLC', type: 'Luxury Real Estate', logo: 'PP', projects: 12, tasks: 35, employees: 8, budget: 8500, color: 'bg-purple-600', image: null, email: 'contact@premiumproperties.com', phone: '(555) 123-4567', address: '123 Luxury Lane, Beverly Hills, CA' },
    { id: 2, name: 'Downtown Developers', type: 'Commercial Developer', logo: 'DD', projects: 18, tasks: 52, employees: 15, budget: 15200, color: 'bg-blue-600', image: null, email: 'info@downtowndev.com', phone: '(555) 234-5678', address: '456 Business Blvd, New York, NY' },
    { id: 3, name: 'Green Valley Realty', type: 'Residential Agency', logo: 'GV', projects: 9, tasks: 28, employees: 6, budget: 4500, color: 'bg-green-600', image: null, email: 'hello@greenvalley.com', phone: '(555) 345-6789', address: '789 Green St, Portland, OR' },
    { id: 4, name: 'Skyline Investments', type: 'Investment Firm', logo: 'SI', projects: 14, tasks: 42, employees: 12, budget: 12000, color: 'bg-orange-600', image: null, email: 'invest@skyline.com', phone: '(555) 456-7890', address: '101 Tower Ave, Chicago, IL' },
    { id: 5, name: 'Coastal Properties', type: 'Beachfront Specialist', logo: 'CP', projects: 22, tasks: 64, employees: 18, budget: 18500, color: 'bg-red-600', image: null, email: 'beach@coastalprops.com', phone: '(555) 567-8901', address: '202 Ocean Drive, Miami, FL' },
    { id: 6, name: 'Urban Living Co', type: 'Apartment Developer', logo: 'UL', projects: 10, tasks: 30, employees: 9, budget: 6800, color: 'bg-pink-600', image: null, email: 'urban@livingco.com', phone: '(555) 678-9012', address: '303 City Center, Austin, TX' },
    { id: 7, name: 'Heritage Estates', type: 'Historic Properties', logo: 'HE', projects: 7, tasks: 20, employees: 5, budget: 3800, color: 'bg-cyan-600', image: null, email: 'history@heritage.com', phone: '(555) 789-0123', address: '404 Heritage Ln, Boston, MA' },
    { id: 8, name: 'Metro Commercial', type: 'Office Space Broker', logo: 'MC', projects: 16, tasks: 48, employees: 13, budget: 11200, color: 'bg-yellow-600', image: null, email: 'office@metrocomm.com', phone: '(555) 890-1234', address: '505 Metro Plaza, Seattle, WA' },
    { id: 9, name: 'Suburban Homes', type: 'Family Housing', logo: 'SH', projects: 11, tasks: 32, employees: 7, budget: 5200, color: 'bg-indigo-600', image: null, email: 'family@suburbanhomes.com', phone: '(555) 901-2345', address: '606 Suburb St, Denver, CO' }
  ];

  const initialCustomers = [
    { id: 1, name: 'Michael Rodriguez', odId: '78901', status: 'Active', totalOrder: 1250000, avgOrder: 625000, orders: 2, lastOrder: '15 Feb 2024, 14:30', avatar: 'https://i.pravatar.cc/150?img=33', email: 'michael.r@email.com', phone: '(555) 111-2222', address: '123 Main St, Los Angeles, CA' },
    { id: 2, name: 'Sarah Chen', odId: '78902', status: 'Active', totalOrder: 850000, avgOrder: 850000, orders: 1, lastOrder: '22 Feb 2024, 11:00', initials: 'SC', avatar: null, email: 'sarah.chen@email.com', phone: '(555) 222-3333', address: '456 Oak Ave, San Francisco, CA' },
    { id: 3, name: 'David Thompson', odId: '78903', status: 'Inactive', totalOrder: 425000, avgOrder: 212500, orders: 2, lastOrder: '10 Jan 2024, 09:45', initials: 'DT', avatar: null, email: 'david.t@email.com', phone: '(555) 333-4444', address: '789 Pine Rd, Seattle, WA' },
    { id: 4, name: 'Emma Wilson', odId: '78904', status: 'Active', totalOrder: 2100000, avgOrder: 700000, orders: 3, lastOrder: '28 Feb 2024, 16:20', avatar: 'https://i.pravatar.cc/150?img=5', email: 'emma.w@email.com', phone: '(555) 444-5555', address: '101 Elm St, Portland, OR' },
    { id: 5, name: 'James Martinez', odId: '78905', status: 'Active', totalOrder: 975000, avgOrder: 487500, orders: 2, lastOrder: '25 Feb 2024, 13:15', initials: 'JM', avatar: null, email: 'james.m@email.com', phone: '(555) 555-6666', address: '202 Maple Dr, Austin, TX' },
    { id: 6, name: 'Lisa Anderson', odId: '78906', status: 'Active', totalOrder: 3500000, avgOrder: 875000, orders: 4, lastOrder: '01 Mar 2024, 10:30', avatar: 'https://i.pravatar.cc/150?img=1', email: 'lisa.a@email.com', phone: '(555) 666-7777', address: '303 Cedar Ln, Miami, FL' },
    { id: 7, name: 'Robert Kumar', odId: '78907', status: 'Inactive', totalOrder: 550000, avgOrder: 275000, orders: 2, lastOrder: '18 Jan 2024, 15:45', initials: 'RK', avatar: null, email: 'robert.k@email.com', phone: '(555) 777-8888', address: '404 Birch Way, Chicago, IL' },
    { id: 8, name: 'Jennifer Lee', odId: '78908', status: 'Active', totalOrder: 4200000, avgOrder: 600000, orders: 7, lastOrder: '03 Mar 2024, 12:00', avatar: 'https://i.pravatar.cc/150?img=20', email: 'jennifer.l@email.com', phone: '(555) 888-9999', address: '505 Walnut St, New York, NY' },
    { id: 9, name: 'Daniel Foster', odId: '78909', status: 'Active', totalOrder: 1800000, avgOrder: 900000, orders: 2, lastOrder: '27 Feb 2024, 14:45', initials: 'DF', avatar: null, email: 'daniel.f@email.com', phone: '(555) 999-0000', address: '606 Spruce Ave, Boston, MA' }
  ];

  // Load clients and customers from localStorage, or use initial data
  const [clients, setClients] = useState(() => {
    try {
      const saved = localStorage.getItem('clients_data');
      return saved ? JSON.parse(saved) : initialClients;
    } catch { return initialClients; }
  });
  
  const [customers, setCustomers] = useState(() => {
    try {
      const saved = localStorage.getItem('customers_data');
      return saved ? JSON.parse(saved) : initialCustomers;
    } catch { return initialCustomers; }
  });
  
  // Persist clients to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('clients_data', JSON.stringify(clients));
  }, [clients]);
  
  // Persist customers to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('customers_data', JSON.stringify(customers));
  }, [customers]);

  // Default client filter tabs
  const defaultClientFilters = [
    { id: 'A-Z', name: 'A-Z', icon: '🔤' },
    { id: 'Budget', name: 'Budget', icon: '💰' },
    { id: 'Projects', name: 'Projects', icon: '📁' },
    { id: 'Tasks', name: 'Tasks', icon: '✅' }
  ];
  
  // Default customer filter tabs
  const defaultCustomerFilters = [
    { id: 'All', name: 'All Customers', icon: '👥' },
    { id: 'Active', name: 'Active', icon: '✅' },
    { id: 'Inactive', name: 'Inactive', icon: '⏸️' }
  ];
  
  // Load custom filters from localStorage
  const [customClientFilters, setCustomClientFilters] = useState(() => {
    try {
      const saved = localStorage.getItem('client_filter_tabs');
      return saved ? JSON.parse(saved) : defaultClientFilters;
    } catch { return defaultClientFilters; }
  });
  
  const [customCustomerFilters, setCustomCustomerFilters] = useState(() => {
    try {
      const saved = localStorage.getItem('customer_filter_tabs');
      return saved ? JSON.parse(saved) : defaultCustomerFilters;
    } catch { return defaultCustomerFilters; }
  });
  
  // Modal states for editing categories
  const [showClientFilterModal, setShowClientFilterModal] = useState(false);
  const [showCustomerFilterModal, setShowCustomerFilterModal] = useState(false);
  const [newFilterName, setNewFilterName] = useState('');
  const [newFilterIcon, setNewFilterIcon] = useState('📋');
  const [editingFilter, setEditingFilter] = useState(null);
  const [editFilterValue, setEditFilterValue] = useState('');
  
  const filterIcons = ['📋', '🔤', '💰', '📁', '✅', '👥', '⏸️', '🏆', '⭐', '🎯', '📊', '📈', '🔥', '💼', '🏢', '👤', '📅', '🔔', '💡', '🎨'];
  
  // Client filter management
  const addClientFilter = () => {
    if (!newFilterName.trim()) return;
    if (customClientFilters.some(f => f.id === newFilterName)) { toast.error('Filter already exists'); return; }
    const newFilter = { id: newFilterName, name: newFilterName, icon: newFilterIcon };
    const updated = [...customClientFilters, newFilter];
    setCustomClientFilters(updated);
    localStorage.setItem('client_filter_tabs', JSON.stringify(updated));
    setNewFilterName('');
    setNewFilterIcon('📋');
    toast.success(`Added "${newFilterName}" filter`);
  };
  
  const updateClientFilter = (oldId, newName) => {
    if (!newName.trim()) return;
    const updated = customClientFilters.map(f => f.id === oldId ? { ...f, id: newName, name: newName } : f);
    setCustomClientFilters(updated);
    localStorage.setItem('client_filter_tabs', JSON.stringify(updated));
    if (clientFilter === oldId) setClientFilter(newName);
    setEditingFilter(null);
    setEditFilterValue('');
    toast.success(`Filter renamed to "${newName}"`);
  };
  
  const deleteClientFilter = (filterId) => {
    if (['A-Z', 'Budget'].includes(filterId)) { toast.error('Cannot delete default filter'); return; }
    const updated = customClientFilters.filter(f => f.id !== filterId);
    setCustomClientFilters(updated);
    localStorage.setItem('client_filter_tabs', JSON.stringify(updated));
    if (clientFilter === filterId) setClientFilter('A-Z');
    toast.success('Filter deleted');
  };
  
  // Customer filter management
  const addCustomerFilter = () => {
    if (!newFilterName.trim()) return;
    if (customCustomerFilters.some(f => f.id === newFilterName)) { toast.error('Filter already exists'); return; }
    const newFilter = { id: newFilterName, name: newFilterName, icon: newFilterIcon };
    const updated = [...customCustomerFilters, newFilter];
    setCustomCustomerFilters(updated);
    localStorage.setItem('customer_filter_tabs', JSON.stringify(updated));
    setNewFilterName('');
    setNewFilterIcon('📋');
    toast.success(`Added "${newFilterName}" filter`);
  };
  
  const updateCustomerFilter = (oldId, newName) => {
    if (!newName.trim()) return;
    const updated = customCustomerFilters.map(f => f.id === oldId ? { ...f, id: newName, name: newName } : f);
    setCustomCustomerFilters(updated);
    localStorage.setItem('customer_filter_tabs', JSON.stringify(updated));
    if (customerFilter === oldId) setCustomerFilter(newName);
    setEditingFilter(null);
    setEditFilterValue('');
    toast.success(`Filter renamed to "${newName}"`);
  };
  
  const deleteCustomerFilter = (filterId) => {
    if (['All', 'Active'].includes(filterId)) { toast.error('Cannot delete default filter'); return; }
    const updated = customCustomerFilters.filter(f => f.id !== filterId);
    setCustomCustomerFilters(updated);
    localStorage.setItem('customer_filter_tabs', JSON.stringify(updated));
    if (customerFilter === filterId) setCustomerFilter('All');
    toast.success('Filter deleted');
  };

  const colorOptions = [
    { value: 'bg-purple-600', label: 'Purple' },
    { value: 'bg-blue-600', label: 'Blue' },
    { value: 'bg-green-600', label: 'Green' },
    { value: 'bg-orange-600', label: 'Orange' },
    { value: 'bg-red-600', label: 'Red' },
    { value: 'bg-pink-600', label: 'Pink' },
    { value: 'bg-cyan-600', label: 'Cyan' },
    { value: 'bg-yellow-600', label: 'Yellow' },
    { value: 'bg-indigo-600', label: 'Indigo' }
  ];

  const [newClient, setNewClient] = useState({
    name: '',
    type: '',
    projects: 0,
    tasks: 0,
    employees: 0,
    budget: 0,
    color: 'bg-purple-600',
    image: null,
    email: '',
    phone: '',
    address: ''
  });

  const [newCustomer, setNewCustomer] = useState({
    name: '',
    status: 'Active',
    totalOrder: 0,
    avgOrder: 0,
    orders: 0,
    avatar: null,
    email: '',
    phone: '',
    address: ''
  });

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const generateLogo = (name) => {
    const words = name.split(' ');
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const generateInitials = (name) => {
    const words = name.split(' ');
    if (words.length >= 2) {
      return (words[0][0] + words[words.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const handleImageUpload = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (type === 'client') {
          setNewClient({ ...newClient, image: reader.result });
        } else if (type === 'customer') {
          setNewCustomer({ ...newCustomer, avatar: reader.result });
        } else if (type === 'details-client') {
          setSelectedItem({ ...selectedItem, image: reader.result });
        } else if (type === 'details-customer') {
          setSelectedItem({ ...selectedItem, avatar: reader.result });
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAddClient = () => {
    if (!newClient.name.trim()) {
      toast.error('Company name is required');
      return;
    }
    if (!newClient.type.trim()) {
      toast.error('Company type is required');
      return;
    }

    const client = {
      id: Date.now(),
      ...newClient,
      logo: generateLogo(newClient.name),
      budget: Number(newClient.budget) || 0,
      projects: Number(newClient.projects) || 0,
      tasks: Number(newClient.tasks) || 0,
      employees: Number(newClient.employees) || 0
    };

    if (editItem) {
      setClients(prev => prev.map(c => c.id === editItem.id ? { ...client, id: editItem.id } : c));
      toast.success('Company updated successfully');
    } else {
      setClients(prev => [...prev, client]);
      toast.success('Company added successfully');
    }

    setShowAddModal(false);
    setEditItem(null);
    setNewClient({ name: '', type: '', projects: 0, tasks: 0, employees: 0, budget: 0, color: 'bg-purple-600', image: null, email: '', phone: '', address: '' });
  };

  const handleAddCustomer = () => {
    if (!newCustomer.name.trim()) {
      toast.error('Customer name is required');
      return;
    }

    const customer = {
      id: Date.now(),
      ...newCustomer,
      odId: String(70000 + Math.floor(Math.random() * 10000)),
      initials: generateInitials(newCustomer.name),
      totalOrder: Number(newCustomer.totalOrder) || 0,
      avgOrder: Number(newCustomer.avgOrder) || 0,
      orders: Number(newCustomer.orders) || 0,
      lastOrder: new Date().toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    };

    if (editItem) {
      setCustomers(prev => prev.map(c => c.id === editItem.id ? { ...customer, id: editItem.id, odId: editItem.odId } : c));
      toast.success('Customer updated successfully');
    } else {
      setCustomers(prev => [...prev, customer]);
      toast.success('Customer added successfully');
    }

    setShowAddCustomerModal(false);
    setEditItem(null);
    setNewCustomer({ name: '', status: 'Active', totalOrder: 0, avgOrder: 0, orders: 0, avatar: null, email: '', phone: '', address: '' });
  };

  const handleDeleteClient = () => {
    if (itemToDelete) {
      setClients(prev => prev.filter(c => c.id !== itemToDelete.id));
      toast.success(`${itemToDelete.name} deleted successfully`);
      setShowDeleteModal(false);
      setItemToDelete(null);
    }
  };

  const handleDeleteCustomer = () => {
    if (itemToDelete) {
      setCustomers(prev => prev.filter(c => c.id !== itemToDelete.id));
      toast.success(`${itemToDelete.name} deleted successfully`);
      setShowDeleteModal(false);
      setItemToDelete(null);
    }
  };

  const openEditClientModal = (client) => {
    setEditItem(client);
    setNewClient({
      name: client.name,
      type: client.type,
      projects: client.projects,
      tasks: client.tasks,
      employees: client.employees,
      budget: client.budget,
      color: client.color,
      image: client.image,
      email: client.email || '',
      phone: client.phone || '',
      address: client.address || ''
    });
    setShowAddModal(true);
    setActiveDropdown(null);
  };

  const openEditCustomerModal = (customer) => {
    setEditItem(customer);
    setNewCustomer({
      name: customer.name,
      status: customer.status,
      totalOrder: customer.totalOrder,
      avgOrder: customer.avgOrder,
      orders: customer.orders,
      avatar: customer.avatar,
      email: customer.email || '',
      phone: customer.phone || '',
      address: customer.address || ''
    });
    setShowAddCustomerModal(true);
    setActiveDropdown(null);
  };

  const openDetailsModal = (item, type) => {
    setSelectedItem({ ...item, itemType: type });
    setShowDetailsModal(true);
    setActiveDropdown(null);
  };

  const openDeleteModal = (item, type) => {
    setItemToDelete({ ...item, itemType: type });
    setShowDeleteModal(true);
    setActiveDropdown(null);
  };

  const handleSaveDetails = () => {
    if (selectedItem.itemType === 'client') {
      setClients(prev => prev.map(c => c.id === selectedItem.id ? { ...selectedItem } : c));
      toast.success('Company details updated');
    } else {
      setCustomers(prev => prev.map(c => c.id === selectedItem.id ? { ...selectedItem } : c));
      toast.success('Customer details updated');
    }
    setShowDetailsModal(false);
    setSelectedItem(null);
  };

  // Filter and sort clients
  const getFilteredClients = () => {
    let filtered = clients.filter(c => 
      c.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.type.toLowerCase().includes(searchTerm.toLowerCase())
    );

    switch (clientFilter) {
      case 'A-Z':
        return filtered.sort((a, b) => a.name.localeCompare(b.name));
      case 'Budget':
        return filtered.sort((a, b) => b.budget - a.budget);
      case 'Projects':
        return filtered.sort((a, b) => b.projects - a.projects);
      case 'Tasks':
        return filtered.sort((a, b) => b.tasks - a.tasks);
      default:
        return filtered;
    }
  };

  // Filter customers
  const getFilteredCustomers = () => {
    let filtered = customers.filter(c => 
      c.name.toLowerCase().includes(customerSearchTerm.toLowerCase()) ||
      c.odId.toLowerCase().includes(customerSearchTerm.toLowerCase())
    );

    if (customerFilter === 'Active') {
      filtered = filtered.filter(c => c.status === 'Active');
    } else if (customerFilter === 'Inactive') {
      filtered = filtered.filter(c => c.status === 'Inactive');
    }

    return filtered;
  };

  const filteredClients = getFilteredClients();
  const filteredCustomers = getFilteredCustomers();

  return (
    <div className="min-h-screen bg-black text-white p-3 md:p-6 overflow-y-auto">
      {/* Header */}
      <div className="mb-4 md:mb-6">
        <div className="flex items-center justify-between mb-3 md:mb-4">
          <h1 className="text-xl md:text-3xl font-bold">Clients & Customers</h1>
        </div>
      </div>

      {/* Tabs */}
      <div className="mb-4 md:mb-6 flex items-center gap-3 md:gap-4 border-b border-white/20">
        {['Clients', 'Customers'].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            data-testid={`tab-${tab.toLowerCase()}`}
            className={`px-4 md:px-6 py-2 md:py-3 text-xs md:text-sm font-semibold transition-all relative ${
              activeTab === tab
                ? 'text-white'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            {tab}
            {activeTab === tab && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-purple-500"></div>
            )}
          </button>
        ))}
      </div>

      {/* Clients Tab Content */}
      {activeTab === 'Clients' && (
        <div className="space-y-4 md:space-y-6">
          {/* Controls */}
          <div className="flex flex-col md:flex-row items-stretch md:items-center justify-between gap-3">
            {/* Filter Buttons */}
            <div className="flex items-center gap-2 md:gap-3 overflow-x-auto pb-2 md:pb-0">
              {customClientFilters.map((filter) => (
                <button
                  key={filter.id}
                  onClick={() => setClientFilter(filter.id)}
                  data-testid={`filter-${filter.id.toLowerCase()}`}
                  className={`px-3 md:px-4 py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-all whitespace-nowrap flex items-center gap-1.5 ${
                    clientFilter === filter.id
                      ? 'bg-purple-600 hover:bg-purple-700'
                      : 'bg-black border border-white/40 hover:border-white/60'
                  }`}
                >
                  <span>{filter.icon}</span>
                  {filter.name}
                </button>
              ))}
              {/* Edit Categories Button */}
              <button
                onClick={() => setShowClientFilterModal(true)}
                data-testid="edit-client-categories-btn"
                className="px-3 py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-all whitespace-nowrap bg-transparent border border-dashed border-gray-500 text-gray-400 hover:bg-gray-800 hover:text-white flex items-center gap-1"
                title="Edit Categories"
              >
                <Pencil size={14} />
                Edit
              </button>
            </div>

            {/* Search and Actions */}
            <div className="flex items-center gap-2 md:gap-3">
              <button 
                onClick={() => setViewMode('grid')}
                data-testid="view-grid-btn"
                className={`hidden md:block p-2 rounded-lg transition-all ${viewMode === 'grid' ? 'bg-purple-600' : 'bg-black border border-white/40 hover:border-white/60 hover:shadow-[0_0_10px_rgba(255,255,255,0.3)]'}`}
              >
                <Grid size={18} />
              </button>
              <button 
                onClick={() => setViewMode('list')}
                data-testid="view-list-btn"
                className={`hidden md:block p-2 rounded-lg transition-all ${viewMode === 'list' ? 'bg-purple-600' : 'bg-black border border-white/40 hover:border-white/60 hover:shadow-[0_0_10px_rgba(255,255,255,0.3)]'}`}
              >
                <List size={18} />
              </button>
              <div className="flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-black border border-white/40 rounded-lg flex-1 md:flex-none md:w-80 focus-within:border-purple-500 transition-all">
                <Search size={16} className="text-gray-400" />
                <input
                  type="text"
                  placeholder="Search companies..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  data-testid="search-clients"
                  className="bg-transparent border-none outline-none text-sm w-full"
                />
                {searchTerm && (
                  <button onClick={() => setSearchTerm('')} className="text-gray-400 hover:text-white">
                    <X size={14} />
                  </button>
                )}
                <span className="hidden md:block text-xs text-gray-500">⌘K</span>
              </div>
              <button 
                onClick={() => {
                  setEditItem(null);
                  setNewClient({ name: '', type: '', projects: 0, tasks: 0, employees: 0, budget: 0, color: 'bg-purple-600', image: null, email: '', phone: '', address: '' });
                  setShowAddModal(true);
                }}
                data-testid="add-company-btn"
                className="flex items-center gap-1.5 md:gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-purple-600 hover:bg-purple-700 rounded-lg text-xs md:text-sm font-medium transition-all whitespace-nowrap"
              >
                <Plus size={16} />
                <span className="hidden sm:inline">Add Company</span>
                <span className="sm:hidden">Add</span>
              </button>
            </div>
          </div>

          {/* Company Cards Grid */}
          <div className={viewMode === 'grid' ? 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6' : 'space-y-3'}>
            {filteredClients.map((client) => (
              <div
                key={client.id}
                data-testid={`client-card-${client.id}`}
                onClick={() => openDetailsModal(client, 'client')}
                className={`bg-black border border-white/40 rounded-xl md:rounded-2xl p-4 md:p-6 hover:border-purple-500/60 hover:shadow-[0_0_20px_rgba(168,85,247,0.2)] transition-all duration-300 cursor-pointer ${viewMode === 'list' ? 'flex items-center gap-4' : ''}`}
              >
                <div className={`flex items-center justify-between ${viewMode === 'list' ? 'flex-1' : 'mb-3 md:mb-4'}`}>
                  <div className="flex items-center gap-2 md:gap-3 min-w-0">
                    {client.image ? (
                      <img src={client.image} alt={client.name} className="w-10 md:w-12 h-10 md:h-12 rounded-lg object-cover flex-shrink-0" />
                    ) : (
                      <div className={`w-10 md:w-12 h-10 md:h-12 ${client.color} rounded-lg flex items-center justify-center text-white font-bold text-sm md:text-lg flex-shrink-0`}>
                        {client.logo}
                      </div>
                    )}
                    <div className="min-w-0">
                      <div className="font-semibold text-sm md:text-base truncate">{client.name}</div>
                      <div className="text-[10px] md:text-xs text-gray-400 truncate">{client.type}</div>
                    </div>
                  </div>
                  <div className="relative" ref={activeDropdown === `client-${client.id}` ? dropdownRef : null}>
                    <button 
                      onClick={(e) => {
                        e.stopPropagation();
                        setActiveDropdown(activeDropdown === `client-${client.id}` ? null : `client-${client.id}`);
                      }}
                      data-testid={`client-menu-${client.id}`}
                      className="p-1 hover:bg-white/10 rounded transition-all flex-shrink-0"
                    >
                      <MoreVertical size={16} />
                    </button>
                    {activeDropdown === `client-${client.id}` && (
                      <div className="absolute right-0 top-8 bg-gray-900 border border-white/20 rounded-lg shadow-xl z-50 min-w-[140px] overflow-hidden">
                        <button 
                          onClick={(e) => { e.stopPropagation(); openEditClientModal(client); }}
                          data-testid={`edit-client-${client.id}`}
                          className="w-full px-4 py-2.5 text-sm text-left hover:bg-white/10 flex items-center gap-2 transition-colors"
                        >
                          <Edit size={14} />
                          Edit
                        </button>
                        <button 
                          onClick={(e) => { e.stopPropagation(); openDetailsModal(client, 'client'); }}
                          data-testid={`view-client-${client.id}`}
                          className="w-full px-4 py-2.5 text-sm text-left hover:bg-white/10 flex items-center gap-2 transition-colors"
                        >
                          <Eye size={14} />
                          View Details
                        </button>
                        <button 
                          onClick={(e) => { e.stopPropagation(); openDeleteModal(client, 'client'); }}
                          data-testid={`delete-client-${client.id}`}
                          className="w-full px-4 py-2.5 text-sm text-left hover:bg-red-500/20 text-red-400 flex items-center gap-2 transition-colors"
                        >
                          <Trash2 size={14} />
                          Delete
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                {viewMode === 'grid' && (
                  <div className="space-y-2 md:space-y-3">
                    <div className="flex items-center justify-between text-xs md:text-sm">
                      <div className="flex items-center gap-1.5 md:gap-2 text-gray-400">
                        <Briefcase size={12} className="md:hidden" />
                        <Briefcase size={14} className="hidden md:block" />
                        <span>Open Projects</span>
                      </div>
                      <span className="font-semibold">{client.projects}</span>
                    </div>
                    <div className="flex items-center justify-between text-xs md:text-sm">
                      <div className="flex items-center gap-1.5 md:gap-2 text-gray-400">
                        <CheckCircle size={12} className="md:hidden" />
                        <CheckCircle size={14} className="hidden md:block" />
                        <span>Open Tasks</span>
                      </div>
                      <span className="font-semibold">{client.tasks}</span>
                    </div>
                    <div className="flex items-center justify-between text-xs md:text-sm">
                      <div className="flex items-center gap-1.5 md:gap-2 text-gray-400">
                        <Users size={12} className="md:hidden" />
                        <Users size={14} className="hidden md:block" />
                        <span>Employees</span>
                      </div>
                      <span className="font-semibold">{client.employees}</span>
                    </div>
                    <div className="flex items-center justify-between text-xs md:text-sm">
                      <div className="flex items-center gap-1.5 md:gap-2 text-gray-400">
                        <DollarSign size={12} className="md:hidden" />
                        <DollarSign size={14} className="hidden md:block" />
                        <span>Budget</span>
                      </div>
                      <span className="font-semibold">${client.budget.toLocaleString()}</span>
                    </div>
                  </div>
                )}

                {viewMode === 'list' && (
                  <div className="flex items-center gap-8 text-sm">
                    <div><span className="text-gray-400">Projects:</span> <span className="font-semibold">{client.projects}</span></div>
                    <div><span className="text-gray-400">Tasks:</span> <span className="font-semibold">{client.tasks}</span></div>
                    <div><span className="text-gray-400">Employees:</span> <span className="font-semibold">{client.employees}</span></div>
                    <div><span className="text-gray-400">Budget:</span> <span className="font-semibold">${client.budget.toLocaleString()}</span></div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {filteredClients.length === 0 && (
            <div className="text-center py-12">
              <Users size={48} className="mx-auto text-gray-600 mb-4" />
              <p className="text-gray-400">No companies found</p>
              <button 
                onClick={() => setShowAddModal(true)}
                className="mt-4 px-4 py-2 bg-purple-600 hover:bg-purple-700 rounded-lg text-sm transition-all"
              >
                Add Your First Company
              </button>
            </div>
          )}

          {/* Pagination */}
          {filteredClients.length > 0 && (
            <div className="flex items-center justify-center gap-1.5 md:gap-2">
              <button className="p-1.5 md:p-2 bg-black border border-white/40 hover:border-white/60 rounded-lg transition-all">
                <ChevronRight size={14} className="rotate-180" />
              </button>
              <button className="px-3 md:px-4 py-1.5 md:py-2 bg-purple-600 rounded-lg text-xs md:text-sm font-medium">1</button>
              <button className="px-3 md:px-4 py-1.5 md:py-2 bg-black border border-white/40 hover:border-white/60 rounded-lg text-xs md:text-sm transition-all">2</button>
              <button className="hidden sm:block px-4 py-2 bg-black border border-white/40 hover:border-white/60 rounded-lg text-sm transition-all">3</button>
              <button className="p-1.5 md:p-2 bg-black border border-white/40 hover:border-white/60 rounded-lg transition-all">
                <ChevronRight size={14} />
              </button>
            </div>
          )}
        </div>
      )}

      {/* Customers Tab Content */}
      {activeTab === 'Customers' && (
        <div className="space-y-4 md:space-y-6">
          {/* KPI Banner */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-6">
            <div className="bg-black border border-white/40 rounded-xl md:rounded-2xl p-4 md:p-6 hover:border-white/60 hover:shadow-[0_0_20px_rgba(255,255,255,0.2)] transition-all duration-300">
              <div className="flex items-center justify-between mb-2 md:mb-3">
                <div className="text-xs md:text-sm text-gray-400">Total Customer</div>
                <Users size={16} className="text-purple-400 md:hidden" />
                <Users size={20} className="text-purple-400 hidden md:block" />
              </div>
              <div className="text-xl md:text-3xl font-bold mb-1 md:mb-2">{customers.length}</div>
              <div className="flex items-center gap-1 text-green-400 text-xs md:text-sm">
                <TrendingUp size={12} />
                <span>+12%</span>
              </div>
            </div>

            <div className="bg-black border border-white/40 rounded-xl md:rounded-2xl p-4 md:p-6 hover:border-white/60 hover:shadow-[0_0_20px_rgba(255,255,255,0.2)] transition-all duration-300">
              <div className="flex items-center justify-between mb-2 md:mb-3">
                <div className="text-xs md:text-sm text-gray-400">Active</div>
                <Users size={16} className="text-blue-400 md:hidden" />
                <Users size={20} className="text-blue-400 hidden md:block" />
              </div>
              <div className="text-xl md:text-3xl font-bold mb-1 md:mb-2">{customers.filter(c => c.status === 'Active').length}</div>
              <div className="flex items-center gap-1 text-green-400 text-xs md:text-sm">
                <TrendingUp size={12} />
                <span>+8%</span>
              </div>
            </div>

            <div className="bg-black border border-white/40 rounded-xl md:rounded-2xl p-4 md:p-6 hover:border-white/60 hover:shadow-[0_0_20px_rgba(255,255,255,0.2)] transition-all duration-300">
              <div className="flex items-center justify-between mb-2 md:mb-3">
                <div className="text-xs md:text-sm text-gray-400">Return Rate</div>
                <TrendingUp size={16} className="text-green-400 md:hidden" />
                <TrendingUp size={20} className="text-green-400 hidden md:block" />
              </div>
              <div className="text-xl md:text-3xl font-bold mb-1 md:mb-2">68%</div>
              <div className="flex items-center gap-1 text-green-400 text-xs md:text-sm">
                <TrendingUp size={12} />
                <span>+5%</span>
              </div>
            </div>

            <div className="bg-black border border-white/40 rounded-xl md:rounded-2xl p-4 md:p-6 hover:border-white/60 hover:shadow-[0_0_20px_rgba(255,255,255,0.2)] transition-all duration-300">
              <div className="flex items-center justify-between mb-2 md:mb-3">
                <div className="text-xs md:text-sm text-gray-400">Avg. Revenue</div>
                <DollarSign size={16} className="text-yellow-400 md:hidden" />
                <DollarSign size={20} className="text-yellow-400 hidden md:block" />
              </div>
              <div className="text-xl md:text-3xl font-bold mb-1 md:mb-2">${Math.round(customers.reduce((a, c) => a + c.avgOrder, 0) / customers.length / 1000)}K</div>
              <div className="flex items-center gap-1 text-green-400 text-xs md:text-sm">
                <TrendingUp size={12} />
                <span>+15%</span>
              </div>
            </div>

            <div className="bg-black border border-white/40 rounded-xl md:rounded-2xl p-4 md:p-6 hover:border-white/60 hover:shadow-[0_0_20px_rgba(255,255,255,0.2)] transition-all duration-300">
              <div className="flex items-center justify-between mb-2 md:mb-3">
                <div className="text-xs md:text-sm text-gray-400">Inactive</div>
                <TrendingDown size={16} className="text-red-400 md:hidden" />
                <TrendingDown size={20} className="text-red-400 hidden md:block" />
              </div>
              <div className="text-xl md:text-3xl font-bold mb-1 md:mb-2">{customers.filter(c => c.status === 'Inactive').length}</div>
              <div className="flex items-center gap-1 text-red-400 text-xs md:text-sm">
                <TrendingDown size={12} />
                <span>-3%</span>
              </div>
            </div>
          </div>

          {/* Filters and Controls */}
          <div className="flex flex-col md:flex-row items-stretch md:items-center justify-between gap-3">
            <div className="flex items-center gap-2 md:gap-3 overflow-x-auto pb-2 md:pb-0">
              {customCustomerFilters.map((filter) => (
                <button 
                  key={filter.id}
                  onClick={() => setCustomerFilter(filter.id)}
                  data-testid={`filter-${filter.id.toLowerCase()}-customers`}
                  className={`px-3 md:px-4 py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-all whitespace-nowrap flex items-center gap-1.5 ${customerFilter === filter.id ? 'bg-purple-600 hover:bg-purple-700' : 'bg-black border border-white/40 hover:border-white/60'}`}
                >
                  <span>{filter.icon}</span>
                  {filter.name}
                </button>
              ))}
              {/* Edit Categories Button */}
              <button
                onClick={() => setShowCustomerFilterModal(true)}
                data-testid="edit-customer-categories-btn"
                className="px-3 py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-all whitespace-nowrap bg-transparent border border-dashed border-gray-500 text-gray-400 hover:bg-gray-800 hover:text-white flex items-center gap-1"
                title="Edit Categories"
              >
                <Pencil size={14} />
                Edit
              </button>
            </div>

            <div className="flex items-center gap-2 md:gap-3 flex-wrap">
              <div className="flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-black border border-white/40 rounded-lg flex-1 md:flex-none focus-within:border-purple-500 transition-all">
                <Search size={16} className="text-gray-400" />
                <input
                  type="text"
                  placeholder="Search customers..."
                  value={customerSearchTerm}
                  onChange={(e) => setCustomerSearchTerm(e.target.value)}
                  data-testid="search-customers"
                  className="bg-transparent border-none outline-none text-sm w-full md:w-40"
                />
                {customerSearchTerm && (
                  <button onClick={() => setCustomerSearchTerm('')} className="text-gray-400 hover:text-white">
                    <X size={14} />
                  </button>
                )}
              </div>
              <button 
                onClick={() => {
                  setEditItem(null);
                  setNewCustomer({ name: '', status: 'Active', totalOrder: 0, avgOrder: 0, orders: 0, avatar: null, email: '', phone: '', address: '' });
                  setShowAddCustomerModal(true);
                }}
                data-testid="add-customer-btn"
                className="flex items-center gap-1.5 md:gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-purple-600 hover:bg-purple-700 rounded-lg text-xs md:text-sm font-medium transition-all whitespace-nowrap"
              >
                <Plus size={16} />
                <span className="hidden sm:inline">Add Customer</span>
                <span className="sm:hidden">Add</span>
              </button>
            </div>
          </div>

          {/* Customer Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
            {filteredCustomers.map((customer) => (
              <div
                key={customer.id}
                data-testid={`customer-card-${customer.id}`}
                onClick={() => openDetailsModal(customer, 'customer')}
                className="bg-black border border-white/40 rounded-xl md:rounded-2xl p-4 md:p-6 hover:border-purple-500/60 hover:shadow-[0_0_20px_rgba(168,85,247,0.2)] transition-all duration-300 cursor-pointer"
              >
                <div className="flex items-center justify-between mb-3 md:mb-4">
                  <div className="flex items-center gap-2 md:gap-3 min-w-0">
                    {customer.avatar ? (
                      <img src={customer.avatar} alt={customer.name} className="w-10 md:w-12 h-10 md:h-12 rounded-full object-cover flex-shrink-0" />
                    ) : (
                      <div className="w-10 md:w-12 h-10 md:h-12 bg-gradient-to-br from-purple-600 to-pink-600 rounded-full flex items-center justify-center text-white font-bold text-sm md:text-base flex-shrink-0">
                        {customer.initials}
                      </div>
                    )}
                    <div className="min-w-0">
                      <div className="font-semibold text-sm md:text-base truncate">{customer.name}</div>
                      <div className="text-[10px] md:text-xs text-gray-400">ID #{customer.odId}</div>
                    </div>
                  </div>
                  <div className="relative" ref={activeDropdown === `customer-${customer.id}` ? dropdownRef : null}>
                    <button 
                      onClick={(e) => {
                        e.stopPropagation();
                        setActiveDropdown(activeDropdown === `customer-${customer.id}` ? null : `customer-${customer.id}`);
                      }}
                      data-testid={`customer-menu-${customer.id}`}
                      className="p-1 hover:bg-white/10 rounded transition-all flex-shrink-0"
                    >
                      <MoreVertical size={16} />
                    </button>
                    {activeDropdown === `customer-${customer.id}` && (
                      <div className="absolute right-0 top-8 bg-gray-900 border border-white/20 rounded-lg shadow-xl z-50 min-w-[140px] overflow-hidden">
                        <button 
                          onClick={(e) => { e.stopPropagation(); openEditCustomerModal(customer); }}
                          data-testid={`edit-customer-${customer.id}`}
                          className="w-full px-4 py-2.5 text-sm text-left hover:bg-white/10 flex items-center gap-2 transition-colors"
                        >
                          <Edit size={14} />
                          Edit
                        </button>
                        <button 
                          onClick={(e) => { e.stopPropagation(); openDetailsModal(customer, 'customer'); }}
                          data-testid={`view-customer-${customer.id}`}
                          className="w-full px-4 py-2.5 text-sm text-left hover:bg-white/10 flex items-center gap-2 transition-colors"
                        >
                          <Eye size={14} />
                          View Details
                        </button>
                        <button 
                          onClick={(e) => { e.stopPropagation(); openDeleteModal(customer, 'customer'); }}
                          data-testid={`delete-customer-${customer.id}`}
                          className="w-full px-4 py-2.5 text-sm text-left hover:bg-red-500/20 text-red-400 flex items-center gap-2 transition-colors"
                        >
                          <Trash2 size={14} />
                          Delete
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                <div className="mb-3 md:mb-4">
                  <span className={`px-2 md:px-3 py-0.5 md:py-1 rounded-full text-[10px] md:text-xs font-medium ${
                    customer.status === 'Active'
                      ? 'bg-green-500/20 text-green-400'
                      : 'bg-red-500/20 text-red-400'
                  }`}>
                    {customer.status}
                  </span>
                </div>

                <div className="space-y-1.5 md:space-y-2 mb-3 md:mb-4">
                  <div className="flex items-center justify-between text-xs md:text-sm">
                    <span className="text-gray-400">Total Order</span>
                    <div className="flex items-center gap-1">
                      <span className="font-semibold">${customer.totalOrder.toLocaleString()}</span>
                      <TrendingUp size={10} className="text-green-400" />
                    </div>
                  </div>
                  <div className="flex items-center justify-between text-xs md:text-sm">
                    <span className="text-gray-400">Avg. Order</span>
                    <div className="flex items-center gap-1">
                      <span className="font-semibold">${customer.avgOrder.toLocaleString()}</span>
                      <TrendingUp size={10} className="text-green-400" />
                    </div>
                  </div>
                  <div className="flex items-center justify-between text-xs md:text-sm">
                    <span className="text-gray-400">No. of Order</span>
                    <span className="font-semibold">{customer.orders}</span>
                  </div>
                </div>

                <div className="pt-3 md:pt-4 border-t border-white/10">
                  <div className="text-[10px] md:text-xs text-gray-400 mb-0.5 md:mb-1">Last Order:</div>
                  <div className="text-xs md:text-sm">{customer.lastOrder}</div>
                </div>
              </div>
            ))}
          </div>

          {filteredCustomers.length === 0 && (
            <div className="text-center py-12">
              <Users size={48} className="mx-auto text-gray-600 mb-4" />
              <p className="text-gray-400">No customers found</p>
              <button 
                onClick={() => setShowAddCustomerModal(true)}
                className="mt-4 px-4 py-2 bg-purple-600 hover:bg-purple-700 rounded-lg text-sm transition-all"
              >
                Add Your First Customer
              </button>
            </div>
          )}
        </div>
      )}

      {/* Add/Edit Company Modal */}
      {showAddModal && (
        <div 
          className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          onClick={() => { setShowAddModal(false); setEditItem(null); }}
        >
          <div 
            className="bg-gray-900 border border-white/20 rounded-2xl w-full max-w-md max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between p-4 border-b border-white/10 sticky top-0 bg-gray-900">
              <h2 className="text-lg font-semibold">{editItem ? 'Edit Company' : 'Add New Company'}</h2>
              <button 
                onClick={() => { setShowAddModal(false); setEditItem(null); }}
                className="p-1 hover:bg-white/10 rounded-lg transition-all"
              >
                <X size={20} />
              </button>
            </div>
            
            <div className="p-4 space-y-4">
              {/* Image Upload */}
              <div className="flex justify-center">
                <div className="relative">
                  <input
                    type="file"
                    ref={fileInputRef}
                    accept="image/*"
                    onChange={(e) => handleImageUpload(e, 'client')}
                    className="hidden"
                  />
                  {newClient.image ? (
                    <img src={newClient.image} alt="Company" className="w-20 h-20 rounded-xl object-cover" />
                  ) : (
                    <div className={`w-20 h-20 ${newClient.color} rounded-xl flex items-center justify-center text-white font-bold text-2xl`}>
                      {newClient.name ? generateLogo(newClient.name) : 'CO'}
                    </div>
                  )}
                  <button
                    onClick={() => fileInputRef.current?.click()}
                    className="absolute -bottom-2 -right-2 p-2 bg-purple-600 rounded-full hover:bg-purple-700 transition-all"
                  >
                    <Camera size={14} />
                  </button>
                </div>
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-1">Company Name *</label>
                <input
                  type="text"
                  value={newClient.name}
                  onChange={(e) => setNewClient({ ...newClient, name: e.target.value })}
                  data-testid="input-company-name"
                  placeholder="Enter company name"
                  className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                />
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-1">Company Type *</label>
                <input
                  type="text"
                  value={newClient.type}
                  onChange={(e) => setNewClient({ ...newClient, type: e.target.value })}
                  data-testid="input-company-type"
                  placeholder="e.g., Real Estate Agency"
                  className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                />
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-1">Brand Color</label>
                <div className="flex flex-wrap gap-2">
                  {colorOptions.map((color) => (
                    <button
                      key={color.value}
                      onClick={() => setNewClient({ ...newClient, color: color.value })}
                      className={`w-8 h-8 rounded-lg ${color.value} ${newClient.color === color.value ? 'ring-2 ring-white ring-offset-2 ring-offset-gray-900' : ''} transition-all`}
                      title={color.label}
                    />
                  ))}
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-400 mb-1">Projects</label>
                  <input
                    type="number"
                    value={newClient.projects}
                    onChange={(e) => setNewClient({ ...newClient, projects: e.target.value })}
                    data-testid="input-projects"
                    className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-400 mb-1">Tasks</label>
                  <input
                    type="number"
                    value={newClient.tasks}
                    onChange={(e) => setNewClient({ ...newClient, tasks: e.target.value })}
                    data-testid="input-tasks"
                    className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-400 mb-1">Employees</label>
                  <input
                    type="number"
                    value={newClient.employees}
                    onChange={(e) => setNewClient({ ...newClient, employees: e.target.value })}
                    data-testid="input-employees"
                    className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-400 mb-1">Budget ($)</label>
                  <input
                    type="number"
                    value={newClient.budget}
                    onChange={(e) => setNewClient({ ...newClient, budget: e.target.value })}
                    data-testid="input-budget"
                    className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-1">Email</label>
                <input
                  type="email"
                  value={newClient.email}
                  onChange={(e) => setNewClient({ ...newClient, email: e.target.value })}
                  placeholder="company@email.com"
                  className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                />
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-1">Phone</label>
                <input
                  type="tel"
                  value={newClient.phone}
                  onChange={(e) => setNewClient({ ...newClient, phone: e.target.value })}
                  placeholder="(555) 123-4567"
                  className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                />
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-1">Address</label>
                <input
                  type="text"
                  value={newClient.address}
                  onChange={(e) => setNewClient({ ...newClient, address: e.target.value })}
                  placeholder="123 Business St, City, State"
                  className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                />
              </div>
            </div>

            <div className="flex items-center justify-end gap-3 p-4 border-t border-white/10 sticky bottom-0 bg-gray-900">
              <button
                onClick={() => { setShowAddModal(false); setEditItem(null); }}
                className="px-4 py-2 bg-black border border-white/20 hover:border-white/40 rounded-lg text-sm transition-all"
              >
                Cancel
              </button>
              <button
                onClick={handleAddClient}
                data-testid="save-company-btn"
                className="px-4 py-2 bg-purple-600 hover:bg-purple-700 rounded-lg text-sm font-medium transition-all"
              >
                {editItem ? 'Save Changes' : 'Add Company'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add/Edit Customer Modal */}
      {showAddCustomerModal && (
        <div 
          className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          onClick={() => { setShowAddCustomerModal(false); setEditItem(null); }}
        >
          <div 
            className="bg-gray-900 border border-white/20 rounded-2xl w-full max-w-md max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between p-4 border-b border-white/10 sticky top-0 bg-gray-900">
              <h2 className="text-lg font-semibold">{editItem ? 'Edit Customer' : 'Add New Customer'}</h2>
              <button 
                onClick={() => { setShowAddCustomerModal(false); setEditItem(null); }}
                className="p-1 hover:bg-white/10 rounded-lg transition-all"
              >
                <X size={20} />
              </button>
            </div>
            
            <div className="p-4 space-y-4">
              {/* Avatar Upload */}
              <div className="flex justify-center">
                <div className="relative">
                  <input
                    type="file"
                    ref={customerFileInputRef}
                    accept="image/*"
                    onChange={(e) => handleImageUpload(e, 'customer')}
                    className="hidden"
                  />
                  {newCustomer.avatar ? (
                    <img src={newCustomer.avatar} alt="Customer" className="w-20 h-20 rounded-full object-cover" />
                  ) : (
                    <div className="w-20 h-20 bg-gradient-to-br from-purple-600 to-pink-600 rounded-full flex items-center justify-center text-white font-bold text-2xl">
                      {newCustomer.name ? generateInitials(newCustomer.name) : 'CU'}
                    </div>
                  )}
                  <button
                    onClick={() => customerFileInputRef.current?.click()}
                    data-testid="upload-customer-avatar"
                    className="absolute -bottom-2 -right-2 p-2 bg-purple-600 rounded-full hover:bg-purple-700 transition-all"
                  >
                    <Camera size={14} />
                  </button>
                </div>
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-1">Customer Name *</label>
                <input
                  type="text"
                  value={newCustomer.name}
                  onChange={(e) => setNewCustomer({ ...newCustomer, name: e.target.value })}
                  data-testid="input-customer-name"
                  placeholder="Enter customer name"
                  className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                />
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-1">Status</label>
                <select
                  value={newCustomer.status}
                  onChange={(e) => setNewCustomer({ ...newCustomer, status: e.target.value })}
                  data-testid="input-customer-status"
                  className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-400 mb-1">Total Orders ($)</label>
                  <input
                    type="number"
                    value={newCustomer.totalOrder}
                    onChange={(e) => setNewCustomer({ ...newCustomer, totalOrder: e.target.value })}
                    data-testid="input-total-order"
                    className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-400 mb-1">Avg. Order ($)</label>
                  <input
                    type="number"
                    value={newCustomer.avgOrder}
                    onChange={(e) => setNewCustomer({ ...newCustomer, avgOrder: e.target.value })}
                    data-testid="input-avg-order"
                    className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-1">Number of Orders</label>
                <input
                  type="number"
                  value={newCustomer.orders}
                  onChange={(e) => setNewCustomer({ ...newCustomer, orders: e.target.value })}
                  data-testid="input-orders"
                  className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                />
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-1">Email</label>
                <input
                  type="email"
                  value={newCustomer.email}
                  onChange={(e) => setNewCustomer({ ...newCustomer, email: e.target.value })}
                  placeholder="customer@email.com"
                  className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                />
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-1">Phone</label>
                <input
                  type="tel"
                  value={newCustomer.phone}
                  onChange={(e) => setNewCustomer({ ...newCustomer, phone: e.target.value })}
                  placeholder="(555) 123-4567"
                  className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                />
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-1">Address</label>
                <input
                  type="text"
                  value={newCustomer.address}
                  onChange={(e) => setNewCustomer({ ...newCustomer, address: e.target.value })}
                  placeholder="123 Main St, City, State"
                  className="w-full px-4 py-2.5 bg-black border border-white/20 rounded-lg text-white focus:border-purple-500 focus:outline-none transition-all"
                />
              </div>
            </div>

            <div className="flex items-center justify-end gap-3 p-4 border-t border-white/10 sticky bottom-0 bg-gray-900">
              <button
                onClick={() => { setShowAddCustomerModal(false); setEditItem(null); }}
                className="px-4 py-2 bg-black border border-white/20 hover:border-white/40 rounded-lg text-sm transition-all"
              >
                Cancel
              </button>
              <button
                onClick={handleAddCustomer}
                data-testid="save-customer-btn"
                className="px-4 py-2 bg-purple-600 hover:bg-purple-700 rounded-lg text-sm font-medium transition-all"
              >
                {editItem ? 'Save Changes' : 'Add Customer'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Details Modal (Click on Card) */}
      {showDetailsModal && selectedItem && (
        <div 
          className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          onClick={() => { setShowDetailsModal(false); setSelectedItem(null); }}
        >
          <div 
            className="bg-gray-900 border border-white/20 rounded-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between p-4 border-b border-white/10 sticky top-0 bg-gray-900">
              <h2 className="text-lg font-semibold">
                {selectedItem.itemType === 'client' ? 'Company Details' : 'Customer Details'}
              </h2>
              <button 
                onClick={() => { setShowDetailsModal(false); setSelectedItem(null); }}
                className="p-1 hover:bg-white/10 rounded-lg transition-all"
              >
                <X size={20} />
              </button>
            </div>
            
            <div className="p-6">
              {/* Header with Image/Avatar */}
              <div className="flex flex-col items-center mb-6">
                <div className="relative mb-4">
                  <input
                    type="file"
                    id="details-image-upload"
                    accept="image/*"
                    onChange={(e) => handleImageUpload(e, selectedItem.itemType === 'client' ? 'details-client' : 'details-customer')}
                    className="hidden"
                  />
                  {selectedItem.itemType === 'client' ? (
                    selectedItem.image ? (
                      <img src={selectedItem.image} alt={selectedItem.name} className="w-24 h-24 rounded-xl object-cover" />
                    ) : (
                      <div className={`w-24 h-24 ${selectedItem.color} rounded-xl flex items-center justify-center text-white font-bold text-3xl`}>
                        {selectedItem.logo}
                      </div>
                    )
                  ) : (
                    selectedItem.avatar ? (
                      <img src={selectedItem.avatar} alt={selectedItem.name} className="w-24 h-24 rounded-full object-cover" />
                    ) : (
                      <div className="w-24 h-24 bg-gradient-to-br from-purple-600 to-pink-600 rounded-full flex items-center justify-center text-white font-bold text-3xl">
                        {selectedItem.initials}
                      </div>
                    )
                  )}
                  <button
                    onClick={() => document.getElementById('details-image-upload')?.click()}
                    data-testid="change-details-image"
                    className="absolute -bottom-2 -right-2 p-2 bg-purple-600 rounded-full hover:bg-purple-700 transition-all"
                  >
                    <Camera size={14} />
                  </button>
                </div>
                
                <input
                  type="text"
                  value={selectedItem.name}
                  onChange={(e) => setSelectedItem({ ...selectedItem, name: e.target.value })}
                  className="text-xl font-bold text-center bg-transparent border-b border-transparent hover:border-white/20 focus:border-purple-500 outline-none px-2 py-1 transition-all"
                />
                
                {selectedItem.itemType === 'client' ? (
                  <input
                    type="text"
                    value={selectedItem.type}
                    onChange={(e) => setSelectedItem({ ...selectedItem, type: e.target.value })}
                    className="text-gray-400 text-sm text-center bg-transparent border-b border-transparent hover:border-white/20 focus:border-purple-500 outline-none px-2 py-1 mt-1 transition-all"
                  />
                ) : (
                  <div className="flex items-center gap-2 mt-2">
                    <span className="text-gray-400 text-sm">ID #{selectedItem.odId}</span>
                    <select
                      value={selectedItem.status}
                      onChange={(e) => setSelectedItem({ ...selectedItem, status: e.target.value })}
                      className={`px-2 py-0.5 rounded-full text-xs font-medium bg-transparent border cursor-pointer ${
                        selectedItem.status === 'Active' ? 'border-green-500 text-green-400' : 'border-red-500 text-red-400'
                      }`}
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                )}
              </div>

              {/* Details Grid */}
              {selectedItem.itemType === 'client' ? (
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div className="bg-black/50 rounded-lg p-3">
                      <div className="text-xs text-gray-400 mb-1">Projects</div>
                      <input
                        type="number"
                        value={selectedItem.projects}
                        onChange={(e) => setSelectedItem({ ...selectedItem, projects: Number(e.target.value) })}
                        className="text-lg font-semibold bg-transparent w-full outline-none"
                      />
                    </div>
                    <div className="bg-black/50 rounded-lg p-3">
                      <div className="text-xs text-gray-400 mb-1">Tasks</div>
                      <input
                        type="number"
                        value={selectedItem.tasks}
                        onChange={(e) => setSelectedItem({ ...selectedItem, tasks: Number(e.target.value) })}
                        className="text-lg font-semibold bg-transparent w-full outline-none"
                      />
                    </div>
                    <div className="bg-black/50 rounded-lg p-3">
                      <div className="text-xs text-gray-400 mb-1">Employees</div>
                      <input
                        type="number"
                        value={selectedItem.employees}
                        onChange={(e) => setSelectedItem({ ...selectedItem, employees: Number(e.target.value) })}
                        className="text-lg font-semibold bg-transparent w-full outline-none"
                      />
                    </div>
                    <div className="bg-black/50 rounded-lg p-3">
                      <div className="text-xs text-gray-400 mb-1">Budget</div>
                      <div className="flex items-center">
                        <span className="text-lg font-semibold">$</span>
                        <input
                          type="number"
                          value={selectedItem.budget}
                          onChange={(e) => setSelectedItem({ ...selectedItem, budget: Number(e.target.value) })}
                          className="text-lg font-semibold bg-transparent w-full outline-none ml-1"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="space-y-3 pt-4 border-t border-white/10">
                    <div>
                      <label className="text-xs text-gray-400">Email</label>
                      <input
                        type="email"
                        value={selectedItem.email || ''}
                        onChange={(e) => setSelectedItem({ ...selectedItem, email: e.target.value })}
                        placeholder="Add email..."
                        className="w-full bg-transparent border-b border-white/10 focus:border-purple-500 outline-none py-1 text-sm"
                      />
                    </div>
                    <div>
                      <label className="text-xs text-gray-400">Phone</label>
                      <input
                        type="tel"
                        value={selectedItem.phone || ''}
                        onChange={(e) => setSelectedItem({ ...selectedItem, phone: e.target.value })}
                        placeholder="Add phone..."
                        className="w-full bg-transparent border-b border-white/10 focus:border-purple-500 outline-none py-1 text-sm"
                      />
                    </div>
                    <div>
                      <label className="text-xs text-gray-400">Address</label>
                      <input
                        type="text"
                        value={selectedItem.address || ''}
                        onChange={(e) => setSelectedItem({ ...selectedItem, address: e.target.value })}
                        placeholder="Add address..."
                        className="w-full bg-transparent border-b border-white/10 focus:border-purple-500 outline-none py-1 text-sm"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div className="bg-black/50 rounded-lg p-3">
                      <div className="text-xs text-gray-400 mb-1">Total Orders</div>
                      <div className="flex items-center">
                        <span className="text-lg font-semibold">$</span>
                        <input
                          type="number"
                          value={selectedItem.totalOrder}
                          onChange={(e) => setSelectedItem({ ...selectedItem, totalOrder: Number(e.target.value) })}
                          className="text-lg font-semibold bg-transparent w-full outline-none ml-1"
                        />
                      </div>
                    </div>
                    <div className="bg-black/50 rounded-lg p-3">
                      <div className="text-xs text-gray-400 mb-1">Avg. Order</div>
                      <div className="flex items-center">
                        <span className="text-lg font-semibold">$</span>
                        <input
                          type="number"
                          value={selectedItem.avgOrder}
                          onChange={(e) => setSelectedItem({ ...selectedItem, avgOrder: Number(e.target.value) })}
                          className="text-lg font-semibold bg-transparent w-full outline-none ml-1"
                        />
                      </div>
                    </div>
                    <div className="bg-black/50 rounded-lg p-3 col-span-2">
                      <div className="text-xs text-gray-400 mb-1">Number of Orders</div>
                      <input
                        type="number"
                        value={selectedItem.orders}
                        onChange={(e) => setSelectedItem({ ...selectedItem, orders: Number(e.target.value) })}
                        className="text-lg font-semibold bg-transparent w-full outline-none"
                      />
                    </div>
                  </div>

                  <div className="bg-black/50 rounded-lg p-3">
                    <div className="text-xs text-gray-400 mb-1">Last Order</div>
                    <div className="text-sm">{selectedItem.lastOrder}</div>
                  </div>

                  <div className="space-y-3 pt-4 border-t border-white/10">
                    <div>
                      <label className="text-xs text-gray-400">Email</label>
                      <input
                        type="email"
                        value={selectedItem.email || ''}
                        onChange={(e) => setSelectedItem({ ...selectedItem, email: e.target.value })}
                        placeholder="Add email..."
                        className="w-full bg-transparent border-b border-white/10 focus:border-purple-500 outline-none py-1 text-sm"
                      />
                    </div>
                    <div>
                      <label className="text-xs text-gray-400">Phone</label>
                      <input
                        type="tel"
                        value={selectedItem.phone || ''}
                        onChange={(e) => setSelectedItem({ ...selectedItem, phone: e.target.value })}
                        placeholder="Add phone..."
                        className="w-full bg-transparent border-b border-white/10 focus:border-purple-500 outline-none py-1 text-sm"
                      />
                    </div>
                    <div>
                      <label className="text-xs text-gray-400">Address</label>
                      <input
                        type="text"
                        value={selectedItem.address || ''}
                        onChange={(e) => setSelectedItem({ ...selectedItem, address: e.target.value })}
                        placeholder="Add address..."
                        className="w-full bg-transparent border-b border-white/10 focus:border-purple-500 outline-none py-1 text-sm"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex items-center justify-between gap-3 p-4 border-t border-white/10 sticky bottom-0 bg-gray-900">
              <button
                onClick={() => openDeleteModal(selectedItem, selectedItem.itemType)}
                className="px-4 py-2 bg-red-600/20 hover:bg-red-600/30 text-red-400 rounded-lg text-sm transition-all flex items-center gap-2"
              >
                <Trash2 size={14} />
                Delete
              </button>
              <div className="flex gap-3">
                <button
                  onClick={() => { setShowDetailsModal(false); setSelectedItem(null); }}
                  className="px-4 py-2 bg-black border border-white/20 hover:border-white/40 rounded-lg text-sm transition-all"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSaveDetails}
                  data-testid="save-details-btn"
                  className="px-4 py-2 bg-purple-600 hover:bg-purple-700 rounded-lg text-sm font-medium transition-all"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && itemToDelete && (
        <div 
          className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-[60] p-4"
          onClick={() => { setShowDeleteModal(false); setItemToDelete(null); }}
        >
          <div 
            className="bg-gray-900 border border-white/20 rounded-2xl w-full max-w-sm overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-6 text-center">
              <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Trash2 size={32} className="text-red-400" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Delete {itemToDelete.itemType === 'client' ? 'Company' : 'Customer'}?</h3>
              <p className="text-gray-400 text-sm mb-6">
                Are you sure you want to delete <span className="text-white font-medium">{itemToDelete.name}</span>? This action cannot be undone.
              </p>
              <div className="flex items-center justify-center gap-3">
                <button
                  onClick={() => { setShowDeleteModal(false); setItemToDelete(null); }}
                  className="px-4 py-2 bg-black border border-white/20 hover:border-white/40 rounded-lg text-sm transition-all"
                >
                  Cancel
                </button>
                <button
                  onClick={itemToDelete.itemType === 'client' ? handleDeleteClient : handleDeleteCustomer}
                  data-testid="confirm-delete-btn"
                  className="px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg text-sm font-medium transition-all"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Client Filter Categories Modal */}
      {showClientFilterModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={() => setShowClientFilterModal(false)}>
          <div className="bg-gray-900 rounded-2xl w-full max-w-md border border-gray-700 shadow-2xl" onClick={e => e.stopPropagation()}>
            <div className="p-4 border-b border-gray-700 flex items-center justify-between">
              <h3 className="text-lg font-bold text-white">Edit Client Filters</h3>
              <button onClick={() => setShowClientFilterModal(false)} className="p-2 hover:bg-gray-800 rounded-lg"><X size={18} className="text-gray-400" /></button>
            </div>
            <div className="p-4 border-b border-gray-700">
              <div className="flex gap-2 mb-3">
                <div className="relative">
                  <button className="w-10 h-10 bg-black border border-gray-600 rounded-lg text-xl flex items-center justify-center" onClick={(e) => e.currentTarget.nextElementSibling.classList.toggle('hidden')}>{newFilterIcon}</button>
                  <div className="hidden absolute top-full left-0 mt-1 bg-gray-800 border border-gray-600 rounded-lg p-2 z-10 grid grid-cols-5 gap-1 w-40">
                    {filterIcons.map(icon => (<button key={icon} onClick={(e) => { setNewFilterIcon(icon); e.currentTarget.parentElement.classList.add('hidden'); }} className="w-7 h-7 hover:bg-gray-700 rounded text-lg flex items-center justify-center">{icon}</button>))}
                  </div>
                </div>
                <input type="text" value={newFilterName} onChange={(e) => setNewFilterName(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && addClientFilter()} placeholder="New filter name..." className="flex-1 px-3 py-2 bg-black border border-gray-600 rounded-lg text-white text-sm" data-testid="new-client-filter-input" />
              </div>
              <button onClick={addClientFilter} disabled={!newFilterName.trim()} className="w-full px-4 py-2 bg-purple-600 hover:bg-purple-500 disabled:bg-gray-700 text-white rounded-lg text-sm font-medium flex items-center justify-center gap-1.5" data-testid="add-client-filter-btn"><Plus size={14} />Add Filter</button>
            </div>
            <div className="p-4 max-h-80 overflow-y-auto space-y-2">
              {customClientFilters.map(cat => (
                <div key={cat.id} className="flex items-center gap-2 p-2 bg-gray-800/50 rounded-lg group">
                  {editingFilter === cat.id ? (
                    <>
                      <span className="text-lg">{cat.icon}</span>
                      <input type="text" value={editFilterValue} onChange={(e) => setEditFilterValue(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') updateClientFilter(cat.id, editFilterValue); if (e.key === 'Escape') { setEditingFilter(null); setEditFilterValue(''); }}} className="flex-1 px-2 py-1 bg-black border border-gray-600 rounded text-white text-sm" autoFocus />
                      <button onClick={() => updateClientFilter(cat.id, editFilterValue)} className="p-1.5 text-green-400 hover:bg-green-500/20 rounded"><Check size={14} /></button>
                      <button onClick={() => { setEditingFilter(null); setEditFilterValue(''); }} className="p-1.5 text-red-400 hover:bg-red-500/20 rounded"><X size={14} /></button>
                    </>
                  ) : (
                    <>
                      <span className="w-8 h-8 rounded-lg bg-gray-700 flex items-center justify-center text-sm">{cat.icon}</span>
                      <span className="flex-1 text-white text-sm">{cat.name}{['A-Z', 'Budget'].includes(cat.id) && <span className="ml-2 text-xs text-gray-500">(default)</span>}</span>
                      <button onClick={() => { setEditingFilter(cat.id); setEditFilterValue(cat.name); }} className="p-1.5 text-gray-400 hover:text-white hover:bg-gray-700 rounded opacity-0 group-hover:opacity-100"><Pencil size={14} /></button>
                      {!['A-Z', 'Budget'].includes(cat.id) && <button onClick={() => deleteClientFilter(cat.id)} className="p-1.5 text-gray-400 hover:text-red-400 hover:bg-red-500/20 rounded opacity-0 group-hover:opacity-100"><Trash2 size={14} /></button>}
                    </>
                  )}
                </div>
              ))}
            </div>
            <div className="p-4 border-t border-gray-700">
              <button onClick={() => setShowClientFilterModal(false)} className="w-full px-4 py-2.5 bg-gray-800 hover:bg-gray-700 text-white rounded-lg text-sm font-medium" data-testid="done-client-filter-btn">Done</button>
            </div>
          </div>
        </div>
      )}

      {/* Customer Filter Categories Modal */}
      {showCustomerFilterModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={() => setShowCustomerFilterModal(false)}>
          <div className="bg-gray-900 rounded-2xl w-full max-w-md border border-gray-700 shadow-2xl" onClick={e => e.stopPropagation()}>
            <div className="p-4 border-b border-gray-700 flex items-center justify-between">
              <h3 className="text-lg font-bold text-white">Edit Customer Filters</h3>
              <button onClick={() => setShowCustomerFilterModal(false)} className="p-2 hover:bg-gray-800 rounded-lg"><X size={18} className="text-gray-400" /></button>
            </div>
            <div className="p-4 border-b border-gray-700">
              <div className="flex gap-2 mb-3">
                <div className="relative">
                  <button className="w-10 h-10 bg-black border border-gray-600 rounded-lg text-xl flex items-center justify-center" onClick={(e) => e.currentTarget.nextElementSibling.classList.toggle('hidden')}>{newFilterIcon}</button>
                  <div className="hidden absolute top-full left-0 mt-1 bg-gray-800 border border-gray-600 rounded-lg p-2 z-10 grid grid-cols-5 gap-1 w-40">
                    {filterIcons.map(icon => (<button key={icon} onClick={(e) => { setNewFilterIcon(icon); e.currentTarget.parentElement.classList.add('hidden'); }} className="w-7 h-7 hover:bg-gray-700 rounded text-lg flex items-center justify-center">{icon}</button>))}
                  </div>
                </div>
                <input type="text" value={newFilterName} onChange={(e) => setNewFilterName(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && addCustomerFilter()} placeholder="New filter name..." className="flex-1 px-3 py-2 bg-black border border-gray-600 rounded-lg text-white text-sm" data-testid="new-customer-filter-input" />
              </div>
              <button onClick={addCustomerFilter} disabled={!newFilterName.trim()} className="w-full px-4 py-2 bg-purple-600 hover:bg-purple-500 disabled:bg-gray-700 text-white rounded-lg text-sm font-medium flex items-center justify-center gap-1.5" data-testid="add-customer-filter-btn"><Plus size={14} />Add Filter</button>
            </div>
            <div className="p-4 max-h-80 overflow-y-auto space-y-2">
              {customCustomerFilters.map(cat => (
                <div key={cat.id} className="flex items-center gap-2 p-2 bg-gray-800/50 rounded-lg group">
                  {editingFilter === cat.id ? (
                    <>
                      <span className="text-lg">{cat.icon}</span>
                      <input type="text" value={editFilterValue} onChange={(e) => setEditFilterValue(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') updateCustomerFilter(cat.id, editFilterValue); if (e.key === 'Escape') { setEditingFilter(null); setEditFilterValue(''); }}} className="flex-1 px-2 py-1 bg-black border border-gray-600 rounded text-white text-sm" autoFocus />
                      <button onClick={() => updateCustomerFilter(cat.id, editFilterValue)} className="p-1.5 text-green-400 hover:bg-green-500/20 rounded"><Check size={14} /></button>
                      <button onClick={() => { setEditingFilter(null); setEditFilterValue(''); }} className="p-1.5 text-red-400 hover:bg-red-500/20 rounded"><X size={14} /></button>
                    </>
                  ) : (
                    <>
                      <span className="w-8 h-8 rounded-lg bg-gray-700 flex items-center justify-center text-sm">{cat.icon}</span>
                      <span className="flex-1 text-white text-sm">{cat.name}{['All', 'Active'].includes(cat.id) && <span className="ml-2 text-xs text-gray-500">(default)</span>}</span>
                      <button onClick={() => { setEditingFilter(cat.id); setEditFilterValue(cat.name); }} className="p-1.5 text-gray-400 hover:text-white hover:bg-gray-700 rounded opacity-0 group-hover:opacity-100"><Pencil size={14} /></button>
                      {!['All', 'Active'].includes(cat.id) && <button onClick={() => deleteCustomerFilter(cat.id)} className="p-1.5 text-gray-400 hover:text-red-400 hover:bg-red-500/20 rounded opacity-0 group-hover:opacity-100"><Trash2 size={14} /></button>}
                    </>
                  )}
                </div>
              ))}
            </div>
            <div className="p-4 border-t border-gray-700">
              <button onClick={() => setShowCustomerFilterModal(false)} className="w-full px-4 py-2.5 bg-gray-800 hover:bg-gray-700 text-white rounded-lg text-sm font-medium" data-testid="done-customer-filter-btn">Done</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RealEstateClientsCustomers;
